import { useDroppable } from "@dnd-kit/core";
import { CustomDraggableArguments, TaskCard } from "../Card/Card";
import {
  IDeclarantApplication,
  IDeclarantsWithApplicationsResponse,
} from "../../types";
import s from "./Column.module.scss";

type ColumnProps = {
  column: IDeclarantsWithApplicationsResponse;
  applications: IDeclarantApplication[];
};

export function Column({ column, applications }: ColumnProps) {
  const { setNodeRef } = useDroppable({
    id: column.id,
  } as CustomDraggableArguments);

  return (
    <div className={s.column}>
      <h2
        className={s.h2}
        // style={{
        //   marginBottom: "16px",
        //   fontWeight: 600,
        //   color: "#f5f5f5",
        // }}
      >
        {column.name}
      </h2>
      <div
        ref={setNodeRef}
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {applications.map((task) => (
          <TaskCard key={task.id} task={task} />
        ))}
      </div>
    </div>
  );
}
